export const config = {
	"mainnet": {
		"derps": {
			"abi": require("./abis/derps.json"),
			"address": "0x8500d84b203775FC8B418148223872b35c43B050"
		},
		"derp": {
			"abi": require("./abis/derp.json"),
			"address": "0xe920d1DA9A4D59126dC35996Ea242d60EFca1304"
		},
		"derper": {
			"abi": require("./abis/derper.json"),
			"address": "0x271E06105AC0eB492d58258Ac1130Ea5564Afa46"
		},
		"treasury": {
			"address": "0x68705637c16bF32A28a82914f7aADEFB3aBE31CD"
		},
		"derpPromoItems": {
			"abi": require("./abis/promoItems.json"),
			"address": "0xc7B2C6CF2Ed40e4514B48a71e3aa0D56a2b14427"
		}

	},
	"testnet": {
		"derps": {
			"abi": require("./abis/derps.json"),
			"address": "0xf7DDC89c07C5e1E8cE8BA3821321543045e19e9c"
		},
		"derp": {
			"abi": require("./abis/derp.json"),
			"address": "0x5fc63611E508879dDD5bdde0782Df0f2E543B172"
		},
		"derper": {
			"abi": require("./abis/derper.json"),
			"address": "0xFc8109734C93543ae601D8876D1280fa6e2704C4"
			//0x80d70BA931a3708aBb4e54492b18300Cf5F32E72
		},
		"treasury": {
			"address": "0xe02237ac085146389e8aCA2E501394bBa75A58e8"
		},
		"derpPromoItems": {
			"abi": require("./abis/promoItems.json"),
			"address": "0x33dF939c84AE702Fd25968B4BD98b943982DA8D4"
		}
	}
}


export const shop = {
	
	"eco": {
		
		"10019": {
			"name": "Boom Poster",
			"img": require("./imgs/tposter-eco-boom.png"),
			"cost": 1000	
		},
		"10023": {
			"name": "Sonic World Tour Poster",
			"img": require("./imgs/tposter-eco-sonic.png"),
			"cost": 1000	
		},
		"10024": {
			"name": "Berps Poster",
			"img": require("./imgs/tposter-berps-berps.png"),
			"cost": 1000	
		},
		"10025": {
			"name": "Knives Poster",
			"img": require("./imgs/tposter-berps-knives.png"),
			"cost": 1000	
		},
		"10026": {
			"name": "Suckers Poster",
			"img": require("./imgs/tposter-berps-suckers.png"),
			"cost": 1000	
		},
		"10027": {
			"name": "Berp Dash Poster",
			"img": require("./imgs/tposter-berps-berpdash.png"),
			"cost": 1000	
		},
		"10028": {
			"name": "LSDerp Poster by Clokkworky",
			"img": require("./imgs/tposter-eco-LSDerp.png"),
			"cost": 1000	
		},
		"10029": {
			"name": "Beibeeeh Poster by Clokkworky",
			"img": require("./imgs/tposter-eco-beibeeeh.png"),
			"cost": 1000	
		},
		"10030": {
			"name": "Magpie Poster",
			"img": require("./imgs/tposter-magpie.png"),
			"cost": 1000	
		},
		"10031": {
			"name": "Eggs Finance Poster",
			"img": require("./imgs/tposter-eggs.png"),
			"cost": 420	
		},
		"10032": {
			"name": "Eggs Finance - Easter Poster",
			"img": require("./imgs/tposter-eggs-easter.png"),
			"cost": 420	
		},
		"10033": {
			"name": "Derpe Easter Poster",
			"img": require("./imgs/tposter-easter.png"),
			"cost": 1	
		},
		"10036": {
			"name": "Da Eggpire Strikes Back Poster",
			"img": require("./imgs/tposter-derp-wars-3-plain.png"),
			"cost": 1	
		},
		"10037": {
			"name": "Derp Wars Poster - Special Edition",
			"img": require("./imgs/tposter-derp-wars-3.png"),
			"cost": 1000	
		},
		"10038": {
			"name": "Paintswap 4 Year Anniversary Poster",
			"img": require("./imgs/tposter-ps.PNG"),
			"cost": 100	
		},
	},
	}
